// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const FormatItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero">
      <path d="M8 17h7v3H8z" />
      <path d="M12.727 20H10l2.273-15H15z" />
      <path d="M10 4h7v3h-7z" />
    </g>
  </svg>
);

export default FormatItalic;
